import * as React from "react";

const DocsIcon = ({ color = "currentColor", ...props }: React.SVGProps<SVGSVGElement> & { color?: string }) => (
  <svg width={20} height={21} viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path fillRule="evenodd" clipRule="evenodd"
          d="M17.2422 11.4728L15.8667 16.566C15.6384 17.4121 14.8715 17.9998 13.9953 17.9998H6.00373C5.12762 17.9998 4.35988 17.4121 4.13148 16.566L2.75688 11.4728C2.42428 10.2407 3.35207 9.02867 4.62829 9.02867H15.37C16.647 9.02867 17.5748 10.2407 17.2422 11.4728Z"
          stroke={color} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round"
    />
    <path d="M4.7347 5.815H15.263M7.03033 3H12.9672" stroke={color} strokeWidth={1.5} strokeLinecap="round"
          strokeLinejoin="round"
    />
  </svg>
);

export default DocsIcon; 